import {
  ENVIRONMENT_PRODUCTION_MEDIA_URL,
  ENVIRONMENT_PRODUCTION_API,
  ENVIRONMENT_PRODUCTION_GENERAL_PROPERTIES
} from '@tangilla/tg-ng-models/src/lib/environments';

export const environment = {
  ...ENVIRONMENT_PRODUCTION_GENERAL_PROPERTIES,
  environmentName: 'production',
  api: ENVIRONMENT_PRODUCTION_API,
  mediaUrl: ENVIRONMENT_PRODUCTION_MEDIA_URL,
  localStorage: {
    prefix: 'tangilla_forms',
    session: 'session',
    person: 'person',
    previousUrl: 'previousUrl',
    previousQueryParameters: 'previousQueryParameters'
  },
};
